module.exports = __webpack_public_path__ + "static/img/All.e46cea41.png";